import React, { useEffect, useState } from 'react';
import {
	FaChevronDown,
	FaChevronUp
} from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import hero from '../Assets/AdobeStock_439136266-scaled.jpeg';
import domaines from '../domaines';

const Domaines = () => {
	const location = useLocation();

	const [expandeddomaine, setExpandeddomaine] = useState(null);
	useEffect(() => {
		// Check if a domaine ID was passed through navigation state
		const state = location.state;
		if (state && state.expandeddomaineId) {
			setExpandeddomaine(state.expandeddomaineId);
		}
	}, [location.state]);

	return (
		<div className='w-full h-auto flex flex-col items-center justify-center my-6'>
			{/* Hero Section */}
			<div
				className='w-full md:w-[80%] p-4 lg:px-24 bg-cover bg-center min-h-[550px] h-auto shadow-lg rounded-xl'
				style={{
					backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 0.7) 60%, rgba(255, 255, 255, 0.5) 80%), url(${hero})`
				}}
				aria-label="CFCAE - Conseil et audit pour entreprises industrielles au Maroc"
			>
				{/* Titre <h2> principal de la section optimisé SEO */}
				<h2 className='text-xl md:text-2xl text-[#87152B] font-bold border-b-2 border-[#87152B] pb-2 mb-6 uppercase'>
					CONSEIL, DIAGNOSTIC INDUSTRIEL & AGRÉMENTS ONEE
				</h2>

				{/* domaines List */}
				<div className='space-y-4'>
					{domaines.map((domaine) => (
						<div
							key={domaine.title}
							className='border border-[#AC9961] rounded-lg shadow-md overflow-hidden transition-all duration-300'
						>
							{/* domaine Header */}
							<div
								className='p-4 bg-[#87152B] text-white cursor-pointer flex justify-between items-center transition-all ease-in-out duration-300'
								onClick={() =>
									setExpandeddomaine(
										expandeddomaine === domaine.title
											? null
											: domaine.title
									)
								}
							>
								{/* Titre H3 pour chaque domaine d'intervention */}
								<h3 className='text-lg font-semibold uppercase tracking-wide'>
									{domaine.title}
								</h3>
								{expandeddomaine === domaine.title ? (
									<FaChevronUp className='w-6 h-6 text-white' />
								) : (
									<FaChevronDown className='w-6 h-6 text-white' />
								)}
							</div>

							{/* Dropdown Content */}
							<div
								className={`transition-all duration-700 ease-in-out ${
									expandeddomaine === domaine.title ? 'max-h-screen' : 'max-h-0'
								} overflow-hidden`}
							>
								<div className='p-4 bg-[white] text-black flex flex-col md:flex-row items-center justify-start'>
									<ul className='list-none py-4 text-xl font-semibold px-5 w-[95%] md:w-[100%]'>
										{domaine.description.split('|').map((line, index) => (
											<li
												key={index}
												className='flex items-start mb-2'
											>
												<span className='mr-2 text-[#87152B] text-lg'>
													●
												</span>
												<span
													dangerouslySetInnerHTML={{ __html: line.trim() }}
													className='text-base md:text-lg font-normal'
												></span>
											</li>
										))}
									</ul>
								</div>
							</div>

						</div>
					))}
					{domaines.length === 0 && (
						<p className='text-center text-gray-500'>
							Aucun domaine trouvé.
						</p>
					)}
				</div>
			</div>
		</div>
	);
};

export default Domaines;